import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { toggleStateBool } from 'functions/actions'
import { loadFonts } from 'functions/digitalTemplate'

import DigitalTemplateWrapper from 'components/digitalTemplates/DigitalTemplateWrapper'
import EditingNavBar from 'agency/digital_renderer/components/EditingNavBar'
import RealhubFooter from 'components/RealhubFooter'

import SectionGroup from './components/SectionGroup'
import Sidebar from './components/Sidebar'
import styles from './styles.scss'

class RealhubDynamic extends React.Component {
  state = {
    showSidebar: false,
  }

  componentDidMount(){
    const { digitalTemplate } = this.props
    const { sidebar } = digitalTemplate.options || {}

    if (sidebar && sidebar.defaultState === 'show'){
      this.setState({
        showSidebar: true,
      })
    }

    loadFonts(digitalTemplate)
  }

  _updateCustomData = (componentId, changes) => {
    const {
      callbacks: { updateCampaignProposal, updateDigitalPage },
      customData,
      dataSourceType,
      dataSource: { id },
    } = this.props

    if (componentId && Object.keys(changes).length){
      const updatedData = { ...customData }
      updatedData[componentId] = {
        ...updatedData[componentId],
        ...changes,
      }

      const dataKey = dataSourceType === 'CampaignProposal' ? 'custom_data' : 'data'

      const updatedProposal = {
        id,
        [dataKey]: JSON.stringify(updatedData),
      }

      const updateFn = dataSourceType === 'CampaignProposal' ? updateCampaignProposal : updateDigitalPage
      updateFn(updatedProposal)
    }
  }

  _callbacks = (component) => {
    const {
      callbacks,
      callbacks: { acceptCampaignProposal },
      campaignProposal,
    } = this.props

    const componentCallbacks = {
      SectionGroup: {
        ...callbacks,
        acceptProposal: () => acceptCampaignProposal(campaignProposal),
        toggleMenu: () => toggleStateBool(this, 'showSidebar'),
        updateCustomData: this._updateCustomData,
      },
      Sidebar: {
        toggleMenu: () => toggleStateBool(this, 'showSidebar'),
      },
    }

    return componentCallbacks[component] || {}
  }

  _renderLayout = (params) => {
    const { showSidebar } = this.state
    const { brand, digitalTemplate, printMode } = this.props

    const { sectionGroups } = params

    const { sidebar: sidebarOptions } = digitalTemplate.options || {}

    return (
      <div className={styles.container}>
        {!printMode && (
          <Sidebar
            brand={brand}
            callbacks={this._callbacks('Sidebar')}
            sectionGroups={sectionGroups}
            showSidebar={showSidebar}
            sidebarOptions={sidebarOptions}
          />
        )}

        <div className={classnames(styles.content, showSidebar ? styles.sidebarActive : null)}>
          {sectionGroups.map(
            sectionGroup => sectionGroup && (
            <SectionGroup
              key={sectionGroup.id}
              callbacks={this._callbacks('SectionGroup')}
              sectionGroup={sectionGroup}
            />
            ),
          )}
        </div>
      </div>
    )
  }

  render(){
    const {
      callbacks,
      campaignProposal,
      dataSource,
      dataSourceType,
      digitalTemplate,
      digitalTemplate: { options },
      digitalTemplatePage: { layout_data = {} },
      editing,
      printMode,
    } = this.props

    const urlString = window.location.search || null
    const decoded = urlString ? decodeURIComponent(urlString) : null
    const redirect = decoded && decoded.includes('redirect') ? decoded.replace(/\?redirect=/, '') : null

    const { footer_theme, footer_link } = options || {}

    return (
      <div className={styles.root}>
        <EditingNavBar
          callbacks={callbacks}
          campaignProposal={campaignProposal}
          dataSource={dataSource}
          dataSourceType={dataSourceType}
          digitalTemplate={digitalTemplate}
          editing={editing}
          redirect={redirect}
        />

        <DigitalTemplateWrapper layoutData={layout_data} render={params => this._renderLayout(params)} />

        {!printMode && (
          <RealhubFooter dark={footer_theme === 'dark'} link={footer_link || 'http://www.realhub.com.au/proposals'} />
        )}
      </div>
    )
  }
}

RealhubDynamic.propTypes = {
  brand: PropTypes.object.isRequired,
  callbacks: PropTypes.shape({
    acceptCampaignProposal: PropTypes.func.isRequired,
    updateCampaignProposal: PropTypes.func.isRequired,
    updateDataStore: PropTypes.func.isRequired,
    updateDigitalPage: PropTypes.func.isRequired,
  }).isRequired,
  campaignProposal: PropTypes.object.isRequired,
  customData: PropTypes.object.isRequired,
  dataSource: PropTypes.object.isRequired,
  dataSourceType: PropTypes.string.isRequired,
  digitalTemplate: PropTypes.object.isRequired,
  digitalTemplatePage: PropTypes.object.isRequired,
  editing: PropTypes.bool,
  printMode: PropTypes.bool,
}

export default RealhubDynamic
